
import { Vue, Component, Prop, Model, Watch } from "vue-property-decorator";
import ContractorClockInModal from "@/components/projects/activities/ContractorClockInModal.vue";
import UIButton from "@/components/button/ui-button.vue";
import FormGroup from "@/components/form/FormGroupNew.vue";
import CircleWithInitials from "@/components/card/CircleWithInitials.vue";
import ModalFullScreen from "@/components/modal/ModalFullScreenNew.vue";
import RouteNames from "@/entities/RouteNames";
import TimeTrackerModal from "@/components/projects/timeTracker/TimeTrackerModalCalendar.vue";
import CrossIconHover from "@/components/icons/CrossIconHover.vue";
import CrossIcon from "@/components/icons/CrossIconNew.vue";
import PlusIcon from "@/components/icons/ArrowIcon.vue";
import HoveredIcon from "@/components/icons/ArrowIconBlack.vue";
import ProjectHeader from "@/components/projects/ProjectHeader.vue";
import NavGrayArrow from "@/components/icons/NavGrayArrow.vue";
import ProfileGray from "@/components/icons/ProfileGray.vue";
import WarningRed from "@/components/icons/WarningRed.vue";
import ClockIcon from "@/components/icons/ClockGray.vue";
import EditTaskAction from "@/components/projects/activities/EditTaskAction.vue";
import SuitableResources from "@/components/projects/activities/SuitableResourcesV2.vue";
import { hslColorFromName } from "@/utils/hslColorFromName";
import LocationGray from "@/components/icons/LocationGray.vue";
import NotesModal from "@/components/projects/activities/NotesModal.vue";
import ChatIcon from "@/components/icons/MsgIcon.vue";
import { User, Skill } from "@/generated/graphql";

@Component({
  components: {
    PlusIcon,
    HoveredIcon,
    ChatIcon,
    ProjectHeader,
    ProfileGray,
    TimeTrackerModal,
    EditTaskAction,
    ClockIcon,
    LocationGray,
    NavGrayArrow,
    NotesModal,
    UIButton,
    FormGroup,
    SuitableResources,
    CircleWithInitials,
    WarningRed,
    ModalFullScreen,
    ContractorClockInModal,
    CrossIconHover,
    CrossIcon,
  },
})
export default class CalendarEventModal extends Vue {
  @Prop({ type: Array, default: [] }) readonly events!: any[];
  @Prop({ type: Object, required: true }) readonly currentUser!: User;

  isHovered: boolean = false;
  selectedEvent: any = null;
  isContractorClockInModal: boolean = false;
  timeTrackerModalOpened = false;
  showNotesModal: boolean = false;
  declineReasonData: any = null;

  contarctorRoute(id) {
    return {
      name: RouteNames.CONTRACTOR_DETAILS_ABOUT,
      params: {
        id: id,
      },
    };
  }
  initial(event, isManager): string {
    const firstName = !isManager ? event.firstName : event.firstName;
    const lastName = !isManager ? event.familyName : event.familyName;

    if (!firstName && !lastName) {
      return "";
    }

    const givenName = firstName ? firstName.trimLeft()[0] : "";
    const familyName = lastName ? lastName.trimLeft()[0] : "";
    return `${givenName}${familyName}`;
  }

  openTimeTrackerModal(event): void {
    this.selectedEvent = event;
    this.timeTrackerModalOpened = true;
  }
  toggleContractorClockInModal(event, status: boolean): void {
    this.selectedEvent = {
      ...event,
      eventObject: {
        ...event.eventObject,
        location: event.location || { lat: null, lng: null },
      },
    };
    this.isContractorClockInModal = status;
  }

  requestSkills(event): Skill[] {
    return event.project_activity_skills.map(({ skill }) => skill);
  }

  skillIds(event): number[] {
    return this.requestSkills(event).map(({ id }: Skill) => id);
  }

  handleShow(event) {
    this.selectedEvent = event;
    this.showNotesModal = true;
  }

  handleClose() {
    this.showNotesModal = false;
    this.selectedEvent = null;
  }
  handleCloseClockIn(){
    this.isContractorClockInModal = false;
    this.selectedEvent = null;
    // Emit event to parent to refresh data if needed
    this.$emit('refreshData');
  }

handleCloseTimeTrackerModal(){
    this.timeTrackerModalOpened = false;
     this.selectedEvent = null;
}
  messageManager(event): void {
    this.$router.push({
      name: RouteNames.INBOX,
      query: {
        recipientUserId: event.managerID,
      },
    });
  }

  bgStyle(event, isManager): object {
    return {
      background: hslColorFromName(this.initial(event, isManager) || ""),
      color: "white",
    };
  }

  message(event): void {
    this.$router.push({
      name: RouteNames.INBOX,
      query: {
        recipientUserId: event.assigneeID,
      },
    });
  }

  closeModal() {
    this.$emit("close");
  }
}
